import React from 'react';
import { ALL_YEARS } from '../constants';

const ArticlesFiltersPanel = ({
  months,
  onMonthSelect,
  onYearChange,
  selectedMonth,
  selectedYear,
  years,
}) => {
  if (years.length === 0) {
    return null;
  }

  return (
    <div className="mt-12 bg-white p-6 rounded-lg border border-gray-200 shadow-lg site-card">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-3">
          <label htmlFor="articles-year" className="text-sm font-semibold text-gray-700">
            Ano
          </label>
          <select
            id="articles-year"
            value={selectedYear ?? ''}
            onChange={onYearChange}
            className="rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value={ALL_YEARS}>Todos</option>
            {years.map((year) => (
              <option key={year} value={year}>
                {year}
              </option>
            ))}
          </select>
        </div>
        {months.length > 0 && (
          <div className="flex flex-wrap gap-2">
            <button
              type="button"
              onClick={() => onMonthSelect(null)}
              className={`rounded-md border px-3 py-1 text-sm font-semibold transition ${
                selectedMonth === null
                  ? 'border-blue-600 bg-blue-600 text-white'
                  : 'border-gray-300 text-gray-600 hover:border-blue-500 hover:text-blue-600'
              }`}
              aria-pressed={selectedMonth === null}
            >
              Todos
            </button>
            {months.map((month) => (
              <button
                key={month.value}
                type="button"
                onClick={() => onMonthSelect(month.value)}
                className={`rounded-md border px-3 py-1 text-sm font-semibold transition ${
                  selectedMonth === month.value
                    ? 'border-blue-600 bg-blue-600 text-white'
                    : 'border-gray-300 text-gray-600 hover:border-blue-500 hover:text-blue-600'
                }`}
                aria-pressed={selectedMonth === month.value}
              >
                {month.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ArticlesFiltersPanel;
